import Vue from 'vue'
import Vuex from 'vuex'
import * as api from '@/api'
import createPersistedState from 'vuex-persistedstate'
import { setCookies } from '@/utils/customCookies.js'
const TOKEN = process.env.VUE_APP_TOKEN

Vue.use(Vuex)

const persistedState = createPersistedState({
  paths: ['isLogin', 'token', 'userInfo', 'equityInformation', 'skillKeys'],
  key: 'ZZT_SSO',
  storage: window.localStorage
})

export default new Vuex.Store({
  namespaced: true,
  state: {
    isLogin: false,
    token: '',
    sessionValue: '',
    // userInfo: {
    //   username: '',
    //   avatar: ''
    // }
    userInfo: {},
    equityInformation: {},//权益信息
    skillKeys: [],
  },
  mutations: {
    setToken(state, payload) {
      state.token = payload
    },
    setLogin(state, payload) {
      state.isLogin = payload
    },
    setUserInfo(state, payload) {
      state.userInfo = payload
    },
    userLogout(state) {
      state.isLogin = false
      state.token = ''
      state.userInfo.username = ''
      state.userInfo.avatar = ''
    },
    setEquityInformation(state, payload) {
      state.equityInformation = payload
    },
    setSkillKeys(state, payload) {
      let array = [...state.skillKeys, payload]
      state.skillKeys = [...new Set(array)]
    }
  },
  actions: {
    login: async ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        api.accountV2.loginWithPassword(data).then((res) => {
          const { data, success } = res
          if (success) {
            const { tokenValue } = data.data
            commit('setLogin', !data.data.isTmpLogin)
            commit('setUserInfo', data.data)
            commit('setToken', tokenValue)
            setCookies({ [TOKEN]: tokenValue }, 12)
            resolve(res)
          } else {
            reject(data.message)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    loginBaseCode: async ({ commit }, params) => {
      return new Promise((resolve, reject) => {
        api.accountV2.loginWithVerificationCode(params).then((res) => {
          const { data, success } = res
          if (success) {
            const { tokenValue } = data.data
            commit('setLogin', !data.data.isTmpLogin)
            commit('setUserInfo', data.data)
            commit('setToken', tokenValue)
            setCookies({ [TOKEN]: tokenValue }, 12)
            resolve(res)
          } else {
            //0033
            if (data.code === "0033") {
              reject('当前账户无PC端权益，如需使用，请点击右侧联系客服开通')
            } else {
              reject(data.message)
            }
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    logOut: async ({ commit }) => {
      await api.logout().then((resp) => {
        commit('userLogout')
        commit('setEquityInformation', {})
      })
    },
    coverLogOut: async ({ commit }) => {
      commit('userLogout')
      commit('setEquityInformation', {})
    },
    getUserInfo: async ({ commit }) => {
      const { data, success } = await api.getUserInfo()
      console.log('getUserInfo', data, success)
      if (success) {
        commit('setLogin', true)
        commit('setUserInfo', data.data)
      } else {
        commit('userLogout')
      }
    },
    updatePersonalRights: async ({ commit }) => {
      return new Promise((resolve, reject) => {
        api.getPersonalRights().then(res => {
          const { data, success } = res
          if (success) {
            commit('setEquityInformation', { ...res.data.data })
            resolve(res)
          } else {
            reject(data.message)
          }
        })
      })
    },
    //切换账号
    switchAccount: async ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        api.accountV2.switchAccount(data).then((res) => {
          const { data, success } = res
          if (success) {
            const { tokenValue } = data.data
            commit('setLogin', true)
            commit('setUserInfo', data.data)
            commit('setToken', tokenValue)
            setCookies({ [TOKEN]: tokenValue }, 12)
            resolve(res)
          } else {
            reject(data.message)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    //当前账号关联手机号绑定新的账号
    bindAccountWithPassword: async ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        api.accountV2.bindAccountWithPassword(data).then((res) => {
          const { data, success } = res
          if (success) {
            const { tokenValue } = data.data
            commit('setLogin', true)
            commit('setUserInfo', data.data)
            commit('setToken', tokenValue)
            setCookies({ [TOKEN]: tokenValue }, 12)
            resolve(res)
          } else {
            reject(data.message)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
  },
  plugins: [persistedState],
  strict: true
})
